export default __webpack_public_path__ + "static/media/gallery_c-min.f20c17dc.jpg";